import { useEffect, useRef, useState } from 'react'

export function useDynamicSvgImport(iconName: string) {
  const importedIconRef = useRef<React.FunctionComponent<React.SVGProps<SVGSVGElement>>>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error>()

  useEffect(() => {
    setLoading(true)
    // dynamically import the mentioned svg icon name in props
    const importIcon = async (): Promise<void> => {
      try {
        importedIconRef.current = (await import(`../assets/svg/${iconName}.svg?react`)).default
      } catch (err: unknown) {
        console.log('🚀 ~ importIcon ~ err:', err)
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }
    importIcon()
  }, [iconName])

  return { error, loading, SvgIcon: importedIconRef.current }
}
